/* eslint-disable import/no-unassigned-import */
import React from 'react';
import Helmet from 'react-helmet';
import { Route, Switch } from 'react-router-dom';
import { AdminApp } from '@sitebuilder/admin-app';
import { auth as coreAuth } from '@sitebuilder/core';
import { LoginPage } from './auth/LoginPage';
import OidcSignInCallback from './auth/OidcSignInCallback';
import OidcSignOutCallback from './auth/OidcSignOutCallback';
import { AuthenticatedRoute } from './auth/AuthenticatedRoute';
import '@sitebuilder/admin-app/src/scss/index.scss';
import './scss/user/index.scss';

const App = ({ user }: { user: coreAuth.User }) => {
    return (
        <React.Fragment>
            <Helmet />
            <Switch>
                <Route path="/_oidc/signin" component={() => <OidcSignInCallback />} />
                <Route path="/_oidc/signout" component={() => <OidcSignOutCallback />} />
                <Route path="/login" component={() => <LoginPage />} />
                <AuthenticatedRoute
                    user={user}
                    path="/admin"
                    component={() => <AdminApp user={user} />}
                />
                <Route
                    path={`/component/:libraryName/:componentId`}
                    exact
                    component={() => <AdminApp user={user} />}
                />
                <Route path={`/:documentName+`} exact component={() => <AdminApp user={user} />} />
            </Switch>
        </React.Fragment>
    );
};

export default App;
